import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  name: string;
  image: string;
  alt: string;
  productCount: number;
  icon: string;
}

interface FeaturedCategoriesProps {
  categories: Category[];
}

const FeaturedCategories = ({ categories }: FeaturedCategoriesProps) => {
  return (
    <section className="py-12 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-3xl font-bold text-foreground mb-2">
              Shop by Category
            </h2>
            <p className="text-muted-foreground">
              Explore our wide range of fresh seafood
            </p>
          </div>
          <Link
            href="/product-listing"
            className="hidden md:flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium transition-smooth hover:shadow-elevation-md hover-lift"
          >
            <span>View All</span>
            <Icon name="ArrowRightIcon" size={18} />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category) => (
            <Link
              key={category.id}
              href="/product-listing"
              className="group bg-card rounded-lg overflow-hidden shadow-elevation-sm hover:shadow-elevation-md transition-smooth hover-lift"
            >
              <div className="relative h-48 overflow-hidden">
                <AppImage
                  src={category.image}
                  alt={category.alt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-smooth"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-heading text-xl font-bold text-white mb-1">
                    {category.name}
                  </h3>
                  <p className="text-white/90 text-sm">
                    {category.productCount} products
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <Link
          href="/product-listing"
          className="md:hidden flex items-center justify-center gap-2 w-full mt-6 px-6 py-3 bg-primary text-primary-foreground rounded-md font-medium transition-smooth hover:shadow-elevation-md"
        >
          <span>View All Categories</span>
          <Icon name="ArrowRightIcon" size={18} />
        </Link>
      </div>
    </section>
  );
};

export default FeaturedCategories;